<template>
    <div class="content">
        <base-header class="pb-6" style="background-color: #248dc1 !important;">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{$store.state.user.sponsor || 'Superusuario'}}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
                <div class="col-lg-6 col-5 text-right">
                
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                <template slot="header">
                    <h3 class="mb-0">Ventas en proceso:</h3>
                    <p class="text-sm mb-0">
                    </p>
                </template>
                <!--
                <div class="list-group list-group-flush">

                    <a v-for="(venta, index) in $store.state.cart" :key="index" class="list-group-item list-group-item-action flex-column align-items-start py-4 px-4">
                        <div class="d-flex w-100 justify-content-between">
                            <div>
                                <div class="d-flex w-100 align-items-center">
                                    <div class="">
                                        <h3 >Cliente: </h3> <h5 >19.150.812-2 | {{venta.cliente.nombres}} {{venta.cliente.paterno}} {{venta.cliente.materno}}</h5>
                                    </div>
                                </div>
                            </div>
                            <small>Ultima actualizacion: {{ venta.fecha_actualizacion  }}</small>
                        </div>
                        <h4 class="mt-3 mb-1"><span class="text-info">●</span> New order for Argon Dashboard</h4>
                        <p class="text-sm mb-0">Doasdnec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius
                            blandit.
                        </p>
                    </a>
                </div>
                -->
                <!-- List group -->
                <ul class="list-group list-group-flush list my--3">
                    <li v-for="(venta, index) in $store.state.cart"
                        :key="index"
                        class="list-group-item px-0 list-group-item-action">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <!-- Avatar -->
                                
                            </div>
                            <div class="col ml--2">
                                <h4 class="mb-0">
                                    <h3 >Cliente: </h3> <h5 >{{venta.cliente.dni}} | {{venta.cliente.nombres}} {{venta.cliente.paterno}} {{venta.cliente.materno}}</h5>
                                </h4>
                                <h4 class="mb-0">
                                    <h3> Plan: </h3><h5>{{venta.plan.nombre}}</h5>
                                </h4>
                                <span :class="'text-default'">● </span>
                                <small>{{venta.estado}} (ID:{{venta.id}})</small> 
                                <br>
                                <br>
                                <base-button @click="verContrato(venta.id)" type="warning" size="sm" nativeType="button">
                                    <i class="fas fa-file-pdf"></i> Ver propuesta
                                </base-button>
                                <br>
                                <small>Última actualización: {{ venta.fecha_actualizacion  }}</small>
                                <br>
                                <base-button @click="eliminarVenta(venta.id)" type="danger" size="sm" nativeType="button">
                                    <i class="fa fa-trash"></i>
                                </base-button>
                            </div>
                            <div class="col-auto">
                                <button v-if="venta.plan.requiere_firma" type="button" class="btn btn-sm btn-default mr-3" @click="ingresarFirma(venta.id)" >Registrar Firma <i class="ni ni-ruler-pencil"></i></button>
                                <br>
                                <br>
                                <button @click="confirmarVenta(venta.id)" type="button" :disabled="!venta.puede_confirmar" class="btn btn-sm btn-primary mr-3">Confirmar <i class="ni ni-bold-right"></i></button>
                                <br>
                                <small v-for="(item,index) in venta.razon" :key="index" style="color:red">{{ item }}<br></small>
                            </div>
                        </div>
                    </li>
                    <li v-if="!$store.state.cart.length" class="list-group-item px-0 list-group-item-action">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                
                            </div>
                            <div class="col ml--2">
                                No hay elementos en el carro.
                                <br>
                                <router-link to="/ventas/crear">Ir a inicio</router-link>
                            </div>
                        </div>
                    </li>
                </ul>
            </card>
        </div>
        <modal-pdf></modal-pdf>
        <modal-firma @firmaSuccess="$store.dispatch('retrieveCart')"></modal-firma>
    </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ModalPdf from '@/views/Cart/ModalPdf.vue';
import ModalFirma from '@/views/Cart/ModalFirma.vue';
import swal from 'sweetalert2';

export default {
    components: {
        RouteBreadCrumb,
        ModalPdf,
        ModalFirma
    },
    methods: {
        verContrato(venta)
        {
            this.$emit('loadModalPdf', venta);
        },
        ingresarFirma(venta_id)
        {
            this.$emit('loadModalFirma', venta_id);
        },
        confirmarVenta(venta_id)
        {

            var vm = this;
            swal({
                title: 'Estás segur@?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, vamos!',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.axios({
                    method: 'POST',
                    url: 'api/ventas/confirm_purchase',
                    data: {
                        venta: venta_id
                    }
                    }).then( response => {
                    
                    vm.$notify({
                        message: 'Venta confirmada correctamente',
                        type: 'success'
                    });
                    vm.$router.push({name: 'Dashboard Ventas'});
                    }).catch( error => {
                    vm.$notify({
                        message: 'Hubo un error, no se pudo confirmar la venta',
                        type: 'danger'
                    });
                    console.log(error);
                    });
                }
            });
                
        },
        eliminarVenta(venta_id)
        {
            var vm = this;
            swal({
                title: 'Estas segur@?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    vm.axios({
                        url: 'api/decline_purchase',
                        method: 'POST',
                        data: {
                            venta_id
                        }
                    }).then( response => {
                        vm.$store.dispatch('retrieveCart');
                    }).catch( error => {
                        if( error.response ){
                            if( error.response.data){
                            Object.keys(error.response.data.errors).forEach( key =>{
                                
                                vm.$notify({
                                message: error.response.data.errors[key][0],
                                timeout: 5000,
                                icon: 'ni ni-bell-55',
                                type: 'warning'
                                });
                            });
                            }
                        }
                    })
                }else{
                    
                }
            });
        }
    }
}
</script>